import React, { useContext } from 'react';
import { Grid, Typography, Paper, makeStyles } from '@material-ui/core';

import { SocketContext } from '../Context';



const VideoPlayer = () => {
  const { name, callAccepted, myVideo, userVideo, callEnded, stream, call } = useContext(SocketContext);

  return (
    <div class="flex flex-col md:flex-row space-y-10 md:space-y-0 md:space-x-10 items-center md:justify-around ">
      {stream && (
        <video class="w-96 md:w-96" muted ref={myVideo} autoPlay />
      )}

      {callAccepted && !callEnded && (
        <video class="w-96 md:w-96" ref={userVideo} autoPlay />

      )}

    </div>
  );
};

export default VideoPlayer;
